<template>
  <v-container fluid class="pa-0 ma-0">
    <PageHeader> CONSULTING </PageHeader>
    <v-row align="center" class="pb-0 pt-15">
      <v-col align="center">
        <h1 class="Black">
          We Make It Work For You
        </h1>
        <hr />
      </v-col>
    </v-row>
    <v-row align="center" class="pt-0 pb-16 pr-16 pl-16">
      <v-col
        align="center"
        style="font-weight: 400; font-family: Raleway; font-style: normal"
      >
        3545 Consulting® takes a consulting approach to every project. Since
        1986, our consultants have been serving clients with a “Never Say No”
        attitude. Our goal is to empower you to make software and infrastructure
        choices that make sense for you, make them work and keep them working.
      </v-col>
    </v-row>
    <v-row class="pb-10">
      <v-col align="center" cols="12" s="12" xs="12" lg="6" xl="6" md="6">
        <ul style="list-style-type: none">
          <li v-for="value in fr_list" :key="value">
            <span v-html="value"></span>
          </li>
        </ul>
      </v-col>
      <v-col align="center" cols="12" s="12" xs="12" lg="6" xl="6" md="6">
        <ul style="list-style-type: none">
          <li v-for="value in sc_list" :key="value">
            <span v-html="value"></span>
          </li>
        </ul>
      </v-col>
    </v-row>
    <!-- <div class="cnsltContainer">
      <v-row
        class="consult mx-4"
        justify="space-around"
        style="background-color: #f9f9f9 !important"
      >
        <v-col
          v-for="(item, index) in consulting_details"
          :key="index"
          align="center"
          cols="12"
          s="12"
          xs="12"
          lg="6"
          xl="6"
          md="6"
        >
          <v-card class="mb-6 pt-10 pb-10" flat max-width="400">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="text-h4 text-wrap cnsltHdr text-left">
                  {{ item.title }}
                  <hr />
                </v-list-item-title>
                <div class="cnsltContent">{{ item.content }}</div>
                <hoveredList
                  v-if="item.useHoveredList"
                  class="cnsltList"
                  :items="item.list"
                />
                <div
                  align="left"
                  style="
                    padding-top: 20px;
                    font-family: Raleway;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 23px;
                  "
                  v-else
                  v-html="item.list"
                ></div>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>
    </div>-->

    <v-row
      class="consult"
      :class="$vuetify.breakpoint.smAndDown ? '':'px-10'"
      justify="space-around"
      style="background-color: #f9f9f9 !important"
    >
      <v-row class="my-4 " :class="$vuetify.breakpoint.smAndDown ? '':'mx-16 pa-4'"
      :style="[$vuetify.breakpoint.smAndDown ? {'color' : 'red'}:{}]"
      >
        <v-col
          v-for="(item, index) in consulting_details"
          :key="index"
          class="colStyle"
          align="left"
          cols="12"
          s="12"
          xs="12"
          lg="6"
          xl="6"
          md="6"
        >
          <div class="my-4 py-4 " :class="$vuetify.breakpoint.smAndDown ? 'px-8':'px-16'">
            <div class="text-h4 text-wrap cnsltHdr text-left">
              {{ item.title }}
              <hr />
            </div>
            <div class="cnsltContent">{{ item.content }}</div>
            <hoveredList
              v-if="item.useHoveredList"
              class="cnsltList"
              :items="item.list"
            />

            <v-container
              align="left"
              style="
                padding-top: 20px;
                font-family: Raleway !important;
                font-size: 20px;
                line-height: 23px;
              "
              v-else
              v-html="item.list"
            >
            </v-container>
          </div>
        </v-col>
      </v-row>
    </v-row>

    <v-row class="contactDiv my-16" align="center">
      <v-col
        class="vcolRight pl-16"
        cols="12"
        s="12"
        xs="12"
        lg="6"
        xl="6"
        md="6"
      >
        <span class="ml-16">
          Get in touch with us today to ask more about our services.</span
        >
      </v-col>

      <v-col
        align="end"
        class="vcolLeft pr-16"
        cols="12"
        s="12"
        xs="12"
        lg="6"
        xl="6"
        md="6"
      >
        <v-btn class="mr-16" outlined color="white"> CONTACT US</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>



<style scoped lang="scss">
.consult {
  padding-left: -15px;
  padding-right: -15px;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: Tahoma !important;
}
hr {
  border-top: 2px solid #a81e2d;
  width: 60px;
  margin-top: 20px;
}
.cnsltContainer {
  background-color: #f9f9f9 !important;
}

.v-card {
  background-color: #f9f9f9 !important;
  margin-top: 20px;
  align-items: left;
}

.cnsltHdr {
  font-family: Poppins;
  letter-spacing: 0;
  color: #222;
  font-style: italic;
  font-weight: 700;
  margin-bottom: 24px;
}
.cnsltContent {
  font-family: Raleway;
  font-style: normal;
  font-weight: 400;
  padding-top: 20px;
  font-size: 15px;
  line-height: 25px;
  color: #222;
}
.cnsltList {
  color: #3d3935;
  font-size: 16px;
  line-height: 18px;
  font-family: open_sansregular;
  margin-bottom: 10px;
}
.contactDiv {
  font-size: 26px;
  color: white;
  font-family: Tahoma, "Helvetica Neue", Helvetica, Arial, sans-serif;
  height: 150px;
  background: #a81e2d;
}
</style>

<script>
import HoveredList from "@/components/global/compnentsMixins/HoveredList.vue";
import PageHeader from "@/components/global/compnentsMixins/PageHeader.vue";
export default {
  components: { HoveredList, PageHeader },
  data() {
    return {
      fr_list: {
        icon: '<img src="https://img.icons8.com/external-icongeek26-outline-icongeek26/64/000000/external-magic-wand-graphic-design-icongeek26-outline-icongeek26.png"/><br /><br />',
        title:
          "<h3 style= 'font-family: Tahoma !important;'>Areas We Consult In</h3><br/>",
        content: `Time/Billing/Productivity/Accounting<br/>
            CRM and Practice Management<br/>
            Document Management and Assembly<br/>
            Calendaring/Docket Control<br/>
            Financial Analysis<br/>
            Database Management<br/>
            Network Systems<br/>
            Phone Systems<br/>`,
      },
      sc_list: {
        icon: '<img src="https://img.icons8.com/external-flatart-icons-outline-flatarticons/64/000000/external-users-cv-resume-flatart-icons-outline-flatarticons.png"/><br /><br />',
        title:
          "<h3 style= 'font-family: Tahoma !important;'>Some Of The Industries We’ve Served</h3><br/>",
        content: `Law Firms, Corporate Legal & Government<br/>
          Small Business<br/>
          Health Care<br/>
          Oil & Gas<br/>
          Not-for-Profit<br/>`,
      },
      consulting_details: [
        {
          useHoveredList: true,
          title: "Billing & Accounting Assistance Services",
          content:
            "We can train you and establish best practices for successful billing & improve your accounting workflow, or you can leave the billing and bookkeeping to us. Our trusted advisors are at your service.",
          list: [
            "Billing Training",
            "Database Design",
            "Temporary Staffing",
            "Electronic Billing (EDI): LEDES, Serengeti, Chubb, TyMetrix",
            "On-going Monthly Billing or Accounting Assistance & Payroll",
            "Billing & Accounting Assistance for Law Firms",
          ],
        },
        {
          useHoveredList: true,
          title: "Database Design & Management",
          content:
            "Are you managing important client information with an outdated MS Access database? Our consultants can help you find an off the shelf Practice Management or CRM software program to ease the burden of data management or we can help you manage an existing one. 3545 Consulting® has the expertise to help you with all of your databases including:",
          list: [
            "Software Selection",
            "Database Design",
            "Database and Software Installation",
            "Data Migration / Conversion",
            "User Training",
            "Ongoing Support",
          ],
        },
        {
          useHoveredList: true,
          title: "Software Selection",
          content:
            "3545 Software Application Specialists will help you find the right software for your business. We learn about your firm’s needs by listening to you and seeing how you work. We work with you to make the software work for you.",
          list: [
            "Needs Assessment",
            "Software Demonstration and Comparison",
            "Implementation Plan",
            "Data Conversion",
            "User Training and Provide Ongoing Support",
            "Financial and Management Reporting and Analysis",
          ],
        },
        {
          useHoveredList: false,
          title: "Software Training",
          content:
            "At 3545 Consulting® we focus not only on how to use the software, but also what the “best practices” for using the software. Our trainers can work with you individually or as a group. We are happy to video record our sessions for you or provide training manuals created for you. Just ask your trainer for details. We support over 100 software applications, but if yours is not on the list, we will learn it and train you anyway.",
          list: `<div><h6>Training Options:<h6><br /><p><strong>Remote</strong><br />We have all of the latest tools to optimize the remote training sessions for one or many.</p> <p><strong>On-site</strong><br/>We will come to you.  Our trainers have traveled around the world.</p></div>`,
        },
      ],
    };
  },
};
</script>

